




import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as util from "@/util";
import * as QRCode from "qrcode";

@Component
export default class QrCodeImg extends Vue {
  @Prop({ default: 200 }) size!: number;
  @Prop({ required: true }) content!: string;

  qrDataURL = "";

  created() {
    this.onValue(this.content, "");
  }

  @Watch("content")
  onValue(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.refreshQR();
    }
  }

  refreshQR() {
    if (!this.content) {
      this.qrDataURL = "";
    } else {
      QRCode.toDataURL(this.content, { width: this.size, errorCorrectionLevel: "M" }, (error, url) => {
        if (!error) {
          this.qrDataURL = url;
        } else {
          this.qrDataURL = "";
          util.logError("Error generating QR code: ", error, ", content=", this.content);
        }
      });
    }
  }
}
